// extracted by mini-css-extract-plugin
export default {"close_btn":"close_button_close_btn__mIvUf"};